import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { App } from '@df/core/app';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { GoogleMapComponent } from '../../../../../module/google-maps/google-map.component';
import { StoreDecorator } from '../../../../model/store/store.decorator';
import { StoreFinderComponent } from '../../../store/finder/store-finder.component';

export interface IPageStoreFinderData extends NICmsContentComponent.IData {}

@Component({
    selector: 'page-component-store-finder',
    templateUrl: './store-finder.component.html',
    styleUrl: './store-finder.scss',
    standalone: true,
    imports: [IfSizeDirective, StoreFinderComponent, GoogleMapComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageStoreFinderComponent>({
    id: 'store-finder',
    name: 'Store finder',
    tags: ['stores', 'feature'],
    fields: [NICmsContentComponent.backgroundField]
})
export class PageStoreFinderComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageStoreFinderData;

    protected app = inject(App);
    stores: StoreDecorator[] = [];

    @ViewChild('storeFinder')
    private storeFinderComponent!: StoreFinderComponent;

    get countryValue(): string | undefined {
        if (['GB'].indexOf(this.app.data.defaultCountry) !== -1) {
            return this.app.data.defaultCountry;
        }

        return undefined;
    }

    onStoreMarkerClicked(storeId: number): void {
        this.storeFinderComponent?.onStoreMarkerClicked(storeId);
    }

    onStoresUpdate(stores: StoreDecorator[]): void {
        this.stores = stores;
        this.detectChanges();
    }
}
